import React, { useEffect, useReducer, useState, useContext } from "react";
import { Link, useHistory } from "react-router-dom";
import { SessionContext } from './SessionContext';

function Header() {

  const { session, setSession } = useContext(SessionContext);
  const history = useHistory();

  const [searchActive, setSearchActive] = useState(0);
  const [catagoryActive, setCatagoryActive] = useState(0);
  const [userDropdown, setuserDropdown] = useState(0);
  const [mobileSideberMenu, setMobileSideberMenu] = useState(0);

  const scrollTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  // Add scroll event listener for sticky header
  useEffect(() => {
    window.addEventListener("scroll", isSticky);
    return () => {
      window.removeEventListener("scroll", isSticky);
    };
  });

  // Handle sticky header on scroll
  const isSticky = () => {
    const header = document.querySelector("header");
    const scrollTop = window.scrollY;
    scrollTop >= 200
      ? header.classList.add("sticky")
      : header.classList.remove("sticky");
  };

  const initialState = { activeMenu: "" };
  const [state, dispatch] = useReducer(reducer, initialState);

  function reducer(state, action) {
    switch (action.type) {
      case "info":
        return { activeMenu: "info" };
      case "workshops":
        return { activeMenu: "workshops" };
      default:
        return { activeMenu: "" };
    }
  }

  const handleMobileSiderbar = () => {
    if (mobileSideberMenu === false || mobileSideberMenu === 0) {
      setMobileSideberMenu(1);
    } else {
      setMobileSideberMenu(false);
    }
  };

  // Update the session currency when the user selects a new currency
  const handleCurrencyChange = (e) => {
    const selectedCurrency = e.target.value;
    // Update our session variable with the new currency
    setSession((prevSession) => ({ ...prevSession, currency: selectedCurrency }));
  };

  return (
    <>
      <header>
        <div className="header-area header-style-four position-absolute w-100">
          <div className="container-fluid">
            <div className="row">
              
              {/* Logo and mobile menu toggle */}
              <div className="col-xxl-2 col-xl-2 col-lg-12 col-md-12 col-sm-12 col-xs-12 align-items-center d-xl-flex d-lg-block">
                <div className="nav-logo d-flex justify-content-between align-items-center">
                <Link to="/" onClick={scrollTop}>
                    <img
                      src={
                        process.env.PUBLIC_URL + "/images/camplogoblue.png"
                      }
                      alt="logo"
                    />
                  </Link>
                  <div className="mobile-menu d-flex">
                    <div className="d-flex align-items-center">
                      <Link
                        to={"#"}
                        className={
                          mobileSideberMenu === 1
                            ? "hamburger d-block d-xl-none h-active"
                            : "hamburger d-block d-xl-none"
                        }
                        onClick={handleMobileSiderbar}
                      >
                        <span className="h-top" />
                        <span className="h-middle" />
                        <span className="h-bottom" />
                      </Link>
                    </div>
                  </div>
                </div>
              </div>

              {/* Main navigation */}
              <div className="col-xxl-7 col-xl-8 col-lg-9 col-md-8 col-sm-6 col-xs-6">
                <nav
                  className={
                    mobileSideberMenu === 1 ? "main-nav slidenav" : "main-nav"
                  }
                >
                  <div className="inner-logo d-xl-none text-center">
                  <Link to="/" onClick={scrollTop}>
                      <img
                        src={
                          process.env.PUBLIC_URL + "/images/camplogoblue.png"
                        }
                        alt=""
                      />
                    </Link>
                  </div>

                  <ul>
                    <li
                      className="has-child-menu"
                      onClick={() => dispatch({ type: "info" })}
                    >
                      <Link to={"#"}>Info</Link>
                      <i className="fl flaticon-plus">+</i>
                      <ul
                        className={
                          state.activeMenu === "info"
                            ? "sub-menu d-block"
                            : "sub-menu d-none"
                        }
                      >
                        <li>
                          <Link
                            onClick={scrollTop}
                            to="/about"
                          >
                            About CAMP
                          </Link>
                        </li>
                        <li>
                          <Link
                            onClick={scrollTop}
                            to="/plus7"
                          >
                            CAMP +7
                          </Link>
                        </li>
                        <li>
                          <Link
                            onClick={scrollTop}
                            to="/funding"
                          >
                            Funding
                          </Link>
                        </li>
                        <li>
                          <Link
                            onClick={scrollTop}
                            to="/faq"
                          >
                            FAQ
                          </Link>
                        </li>
                        <li>
                          <Link
                            onClick={scrollTop}
                            to="/jobs"
                          >
                            Jobs
                          </Link>
                        </li>
                      </ul>
                    </li>
                    <li>
                      <Link
                        onClick={scrollTop}
                        to="/workshops"
                      >
                        Workshops
                      </Link>
                    </li>                   
                    <li>
                      <Link
                        onClick={scrollTop}
                        to="/residencies"
                      >
                        Residencies
                      </Link>
                    </li>
                    <li>
                      <Link
                        onClick={scrollTop}
                        to="/bundles"
                      >
                        Bundles
                      </Link>
                    </li>
                    <li>
                      <Link
                        onClick={scrollTop}
                        to="/gallery"
                      >
                        Gallery
                      </Link>
                    </li>
                    <li>
                      <Link
                        onClick={scrollTop}
                        to="/contact"
                      >
                        Contact
                      </Link>
                    </li>
                    <li>
                      <Link
                        onClick={scrollTop}
                        to="/subscribe"
                      >
                        Subscribe
                      </Link>
                    </li>
                    {/* Mobile currency select: visible only on mobile */}
                    <li className="d-block d-xl-none mt-3">
                      <div className="currency-select">
                        <select
                          onChange={handleCurrencyChange}
                          value={session.currency}  // controlled component
                        >
                          <option value="eur">EUR</option>
                          <option value="gbp">GBP</option>
                          <option value="usd">USD</option>
                        </select>
                      </div>
                    </li>
                  </ul>
                </nav>
              </div>
              {/* Desktop currency select: shown on larger screens */}
              <div className="col-xxl-3 col-xl-2 d-none d-xl-flex align-items-center justify-content-end">
                <div className="currency-select">
                  <select
                    onChange={handleCurrencyChange}
                    value={session.currency}  // controlled component
                  >
                    <option value="eur">EUR</option>
                    <option value="gbp">GBP</option>
                    <option value="usd">USD</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
    </>
  );
}

export default Header;
